import { Divider, Paper } from '@mui/material';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import { BiBriefcase } from 'react-icons/bi';
import { LuPlane } from 'react-icons/lu';

import { revalenceOptions } from '../../../features/jobsCrm/utils/sourcingHelper';
import AdvancedFiltersHeader from '../../../utils/AdvancedFiltersHeader';
import RelevanceSlider from '../../WsCustomSlider/RelevanceSlider';
import { AiContactAvailabilityFilter } from '../components';
import { jobPreferences, workAuthorization } from '../components/AdvanceFilterHelper';
import AiLocationFilter from '../components/AiLocationsFilter';
import CheckboxListFilter from '../components/CheckboxListFilter';
import JobsCrmSmartSourceAdvanceFiltersProps from '../models/JobsCrmSmartSourceAdvanceFiltersProps';

const WsJobsCrmSmartSourceAdvanceFilter = ({ job }: JobsCrmSmartSourceAdvanceFiltersProps) => (
  <Paper sx={{ p: 0 }}>
    <Box>
      <AdvancedFiltersHeader />
      <Divider />
      <List>
        <RelevanceSlider title="Relevance" name="relevance" marks={revalenceOptions} />
        <AiLocationFilter name="aiLocations" job={job} />
        <AiContactAvailabilityFilter name="contactAvailability" />
        <CheckboxListFilter
          name="jobPreference"
          options={jobPreferences}
          title="Job Preference"
          defaultExpanded={true}
          startIcon={<BiBriefcase />}
        />
        <CheckboxListFilter
          name="workAuthorization"
          options={workAuthorization}
          title="Work Authorization"
          defaultExpanded={true}
          startIcon={<LuPlane />}
        />
      </List>
    </Box>
  </Paper>
);
export default WsJobsCrmSmartSourceAdvanceFilter;
